export const EPISODES = [
  {
    id: "ep-09",
    number: "09",
    title: "A Nation Under Whose God",
    description:
      "A candid look at what it means to invoke God in the public square today — where language becomes shorthand, where conviction gets tested, and where honest disagreement can still build up a country.",
    date: "Jul 27, 2026",
    duration: "52 min",
    type: "Open conversation",
    track: "Faith & Politics",
    with: ["Truth & Liberty", "Patriot Academy"],
    image: "/figma/player-art.png",
    comingSoon: true,
    showNotes: {
      covers: [
        "Why founding-era language about God still matters",
        "The difference between civic religion and living faith",
        "How to hold conviction without contempt for a neighbor",
      ],
      sponsors: ["Truth & Liberty", "Patriot Academy"],
    },
  },
  {
    id: "ep-08",
    number: "08",
    title: "From the Waiting Room to the Word",
    description:
      "A first-person testimony about the long seasons of waiting — for answers, for healing, for direction — and the Word that arrived to steady the room every time.",
    date: "Jul 20, 2026",
    duration: "48 min",
    type: "Guest testimony",
    track: "Testimony Tuesday",
    with: ["Charis Bible College"],
    image: "/figma/ep-3.png",
    showNotes: {
      covers: [
        "The long seasons of waiting — for answers, for healing, for direction",
        "What steadied the room when the answers didn\u2019t come",
        "Why the Word arrived exactly when it was needed most",
      ],
      sponsors: ["Charis Bible College"],
    },
  },
  {
    id: "ep-07",
    number: "07",
    title: "Faithful Citizenship in a Loud Culture",
    description:
      "A working definition of faithful citizenship — one that isn't loud for its own sake, and isn't quiet where truth is needed. Practical rhythms for showing up in your city.",
    date: "Jul 13, 2026",
    duration: "55 min",
    type: "Open conversation",
    track: "Faith & Politics",
    with: ["Patriot Academy", "Leadership Institute"],
    image: "/figma/player-art.png",
    showNotes: {
      covers: [
        "A working definition of faithful citizenship",
        "Why it isn\u2019t loud for its own sake — and isn\u2019t quiet where truth is needed",
        "Practical rhythms for showing up in your city",
      ],
      sponsors: ["Patriot Academy", "Leadership Institute"],
    },
  },
  {
    id: "ep-06",
    number: "06",
    title: "The Long Yes — a Missionary Story",
    description:
      "A guest tells the story of a slow, quiet decision to keep saying yes — through language school, through hardship, and through the years when the fruit was invisible.",
    date: "Jul 6, 2026",
    duration: "46 min",
    type: "Guest testimony",
    track: "Testimony Tuesday",
    with: ["RLM Congo", "Ambassadors to the Nations"],
    image: "/figma/cause-missions.jpg",
    showNotes: {
      covers: [
        "A slow, quiet decision to keep saying yes",
        "Through language school, through hardship, through invisible fruit",
        "What sustains a missionary family through the unseen years",
      ],
      sponsors: ["RLM Congo", "Ambassadors to the Nations"],
    },
  },
  {
    id: "ep-05",
    number: "05",
    title: "The Word and the World",
    description:
      "Where do the truth-claims of Scripture meet the arguments of the culture? A patient walkthrough of how to hold Scripture as authoritative while listening honestly to a neighbor.",
    date: "Jun 29, 2026",
    duration: "50 min",
    type: "Open conversation",
    track: "Faith & Politics",
    with: ["Truth & Liberty"],
    image: "/figma/cause-family.png",
    showNotes: {
      covers: [
        "Where the truth-claims of Scripture meet the arguments of the culture",
        "How to hold Scripture as authoritative",
        "How to listen honestly to a neighbor at the same time",
      ],
      sponsors: ["Truth & Liberty"],
    },
  },
  {
    id: "ep-04",
    number: "04",
    title: "Motherhood, Prayer, and Daily Rhythms",
    description:
      "A conversation about how prayer actually happens in a house full of children — the honest, imperfect rhythms that keep a mother tethered to what matters most.",
    date: "Jun 22, 2026",
    duration: "44 min",
    type: "Guest testimony",
    track: "Testimony Tuesday",
    with: ["The Widows Project"],
    image: "/figma/cause-community.png",
    showNotes: {
      covers: [
        "How prayer actually happens in a house full of children",
        "The honest, imperfect rhythms that keep a mother tethered",
        "What matters most — and what can wait",
      ],
      sponsors: ["The Widows Project"],
    },
  },
  {
    id: "ep-03",
    number: "03",
    title: "Faith in a Loud Culture",
    description:
      "The volume keeps rising — on every platform, in every conversation. What does a quiet, unshakable faith look like in the middle of it, and how do we help each other stay there?",
    date: "Jun 15, 2026",
    duration: "51 min",
    type: "Open conversation",
    track: "Faith & Politics",
    with: ["Normalizing God"],
    image: "/figma/player-art.png",
    showNotes: {
      covers: [
        "Why the volume keeps rising — on every platform, in every conversation",
        "What a quiet, unshakable faith looks like in the middle of it",
        "How we help each other stay there",
      ],
      sponsors: ["Normalizing God"],
    },
  },
  {
    id: "ep-02",
    number: "02",
    title: "Faith in the Everyday",
    description:
      "Not every testimony has a lightning-strike moment. A guest shares what it's been like to walk with Jesus through ordinary weeks — and why ordinary is where most of the story happens.",
    date: "Jun 8, 2026",
    duration: "42 min",
    type: "Guest testimony",
    track: "Testimony Tuesday",
    with: [],
    image: "/figma/cause-education.png",
    showNotes: {
      covers: [
        "Not every testimony has a lightning-strike moment",
        "Walking with Jesus through ordinary weeks",
        "Why ordinary is where most of the story happens",
      ],
      sponsors: [],
    },
  },
  {
    id: "ep-01",
    number: "01",
    title: "First Testimonies — Where This Began",
    description:
      "The pilot conversation. Why Stephanie started the podcast, what she wants to make room for, and the first guest who agreed to sit across from her and say what God has done.",
    date: "Jun 1, 2026",
    duration: "39 min",
    type: "Guest testimony",
    track: "Testimony Tuesday",
    with: [],
    image: "/figma/cause-education.png",
    showNotes: {
      covers: [
        "Why Stephanie started the podcast",
        "What she wants to make room for",
        "The first guest who agreed to sit across from her and say what God has done",
      ],
      sponsors: [],
    },
  },
];

export const getEpisode = (id) => EPISODES.find((e) => e.id === id);

export const relatedEpisodes = (episode, count = 3) =>
  EPISODES.filter((e) => e.id !== episode.id).slice(0, count);
